import React from "react";
import {css, cx} from "@panda/css";

import {getAplaClassNames} from "@pg-design/apla-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

interface IArticleGallery {
    image_url: string | null;
}

interface IProps {
    article: {
        author: {
            name: string;
        };
        update_date: string | null;
        header: string;
        excerpt: string;
        gallery: IArticleGallery | (IArticleGallery | undefined)[] | null;
        id: number;
        slug: string;
        title: string;
    };
}

export const ArticleBox = ({article}: IProps) => {
    const link = rpAppLink.article.detail({articleId: article.id, articleSlug: article.slug});
    const galleryItem = Array.isArray(article.gallery) ? article.gallery[0] : article.gallery;
    const src = getThumbnailLink(galleryItem?.image_url, 440, 440);

    const target = useResponsiveLinkTarget();
    const articleBoxHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        window.open(link, "_blank");
    };

    return (
        <div className={articleBox} onClick={(e) => articleBoxHandler(e)}>
            <div>
                <div className={cx(getAplaClassNames("dark"), overlay)} />
            </div>

            <figure className={expandToParent}>
                <Image className={expandToParent} src={src} width="440px" height="440px" alt={article.title} ratio={{xs: "1/1"}} loading="lazy" />

                <figcaption className={articleDetails}>
                    <a href={link} className={articleLink} target={target}>
                        <Text className={textWhite} variant="headline_5" as="p">
                            {article.header}
                        </Text>
                    </a>
                    <div className={articleMeta}>
                        <Text className={textWhite} variant="body_copy_1">
                            {formatDate(article.update_date)}
                        </Text>
                        <Text className={textWhite} variant="body_copy_1">
                            {article.author.name}
                        </Text>
                    </div>
                </figcaption>
            </figure>
        </div>
    );
};

const articleBox = css({
    maxWidth: "36rem",
    width: "100%",
    overflow: "hidden",
    position: "relative",
    borderRadius: 1,
    "&:hover": {
        cursor: "pointer"
    }
});

const overlay = css({
    width: "100%",
    height: "calc(100% - 2.4rem)",
    position: "absolute !important",
    bottom: 0
});

const expandToParent = css({
    width: "100%",
    height: "100%",
    margin: 0
});

const articleLink = css({
    display: "block",
    "&:hover, &:focus": {
        color: "inherit",
        textDecoration: "none"
    }
});

const articleDetails = css({
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: "1.6rem 1.6rem 7.2rem",
    color: "#fff",
    zIndex: 2
});

const articleMeta = css({
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: 2,
    width: "calc(100% - 3.2rem)"
});

const textWhite = css({
    color: "#fff"
});
import React from "react";
import {css, cx} from "@panda/css";

import {getAplaClassNames} from "@pg-design/apla-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

interface IArticleGallery {
    image_url: string | null;
}

interface IProps {
    article: {
        author: {
            name: string;
        };
        update_date: string | null;
        header: string;
        excerpt: string;
        gallery: IArticleGallery | (IArticleGallery | undefined)[] | null;
        id: number;
        slug: string;
        title: string;
    };
}

export const ArticleBox = ({article}: IProps) => {
    const link = rpAppLink.article.detail({articleId: article.id, articleSlug: article.slug});
    const galleryItem = Array.isArray(article.gallery) ? article.gallery[0] : article.gallery;
    const src = getThumbnailLink(galleryItem?.image_url, 440, 440);

    const target = useResponsiveLinkTarget();
    const articleBoxHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        window.open(link, "_blank");
    };

    return (
        <div className={articleBox} onClick={(e) => articleBoxHandler(e)}>
            <div>
                <div className={cx(getAplaClassNames("dark"), overlay)} />
            </div>

            <figure className={expandToParent}>
                <Image className={expandToParent} src={src} width="440px" height="440px" alt={article.title} ratio={{xs: "1/1"}} loading="lazy" />

                <figcaption className={articleDetails}>
                    <a href={link} className={articleLink} target={target}>
                        <Text className={textWhite} variant="headline_5" as="p">
                            {article.header}
                        </Text>
                    </a>
                    <div className={articleMeta}>
                        <Text className={textWhite} variant="body_copy_1">
                            {formatDate(article.update_date)}
                        </Text>
                        <Text className={textWhite} variant="body_copy_1">
                            {article.author.name}
                        </Text>
                    </div>
                </figcaption>
            </figure>
        </div>
    );
};

const articleBox = css({
    maxWidth: "36rem",
    width: "100%",
    overflow: "hidden",
    position: "relative",
    borderRadius: 1,
    "&:hover": {
        cursor: "pointer"
    }
});

const overlay = css({
    width: "100%",
    height: "calc(100% - 2.4rem)",
    position: "absolute !important",
    bottom: 0
});

const expandToParent = css({
    width: "100%",
    height: "100%",
    margin: 0
});

const articleLink = css({
    display: "block",
    "&:hover, &:focus": {
        color: "inherit",
        textDecoration: "none"
    }
});

const articleDetails = css({
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: "1.6rem 1.6rem 7.2rem",
    color: "#fff",
    zIndex: 2
});

const articleMeta = css({
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: 2,
    width: "calc(100% - 3.2rem)"
});

const textWhite = css({
    color: "#fff"
});
